// Author thq
// Date 2024-03-18 15:36:48

import * as model from "@/model/em/statusCollection/TpmAxisCoordinateDataAcdModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.TpmAxisCoordinateDataAcd(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
